import { Component } from '@angular/core';
import { slideInAnimation } from './../_services/modal-animations';
import { MessagingService } from "../_services/messaging.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [ slideInAnimation ]
})
export class AppComponent {
  title = 'PUPS-angular';
    message: any;
    constructor(private msgService: MessagingService) {
  }

  ngOnInit() {
    this.msgService.requestPermission();
    this.msgService.getPermission();
    this.msgService.listen();
    this.message = this.msgService.currentMessage;
    localStorage.removeItem('close')
  }
}
